import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { epochToDate } from "utility/dateFormat";

interface Props {
    value?: number;
    row?: any;
}

const DateTimeCell: React.FC<Props> = ({ value, row }) => {
    console.log("value:", value, typeof value);
    console.log("row:", row);

    // ✅ Strict check
    if (!value || (row && row.isPending === true)) {
        return (
            <div className="flex items-center">
                <div className="flex-shrink-0 h-7 w-7 rounded-full bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 flex items-center justify-center mr-2">
                    <FontAwesomeIcon icon={faCalendarAlt} className="text-sm" />
                </div>
                <div>
                    <div className="font-medium text-gray-800 dark:text-gray-200">
                        N/A
                    </div>
                </div>
            </div>
        );
    }

    const formatted = epochToDate(Number(value));

    // ✅ Safety check
    if (!formatted || !formatted.includes(",")) {
        return <span>N/A</span>;
    }

    const [date, time] = formatted.split(",");

    return (
        <div className="flex items-center">
            <div className="flex-shrink-0 h-7 w-7 rounded-full bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 flex items-center justify-center mr-2">
                <FontAwesomeIcon icon={faCalendarAlt} className="text-sm" />
            </div>
            <div>
                <div className="font-medium text-gray-800 dark:text-gray-200">
                    {date}
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                    {time}
                </div>
            </div>
        </div>
    );
};
export default DateTimeCell;